import * as R from 'ramda';
import React, { Component } from 'react';

import { Tabs, Tab, Row, Col, Collapse, Button, Toast } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import RevenueParameters from './Parameters/RevenueParameters';
import PayorMixParameters from './Parameters/PayorMixParameters';
import MarginProfitParameters from './Parameters/MarginProfitParameters';
import DrugAccessVariables from './Variables/DrugAccessVariables';
import PhysicianVariables from './Variables/PhysicianVariables';
import PatientRxVariables from './Variables/PatientRxVariables';
import PayorAccessVariables from './Variables/PayorAccessVariables';
import B340Variables from './Variables/B340Variables';
import { modelChangeAction, setModifiedDateAction } from '../../../../stores/actions/modelDetails';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faUndo, faAngleDown, faAngleUp, faSlidersH } from '@fortawesome/free-solid-svg-icons';
import ToggleButton from 'react-toggle-button';
import { Config } from '../../../../shared/config';
import modelInputService from './modelInputService';
import modelDetailsService from './../ModelDetails/modelDetailsService';
import { modalOnOpenAction, modalOnCloseAction } from '../../../../stores/actions/modalOnChange';
import ShowModal from '../../../Common/Modal/modal';
import './modelInputStyle.scss';
import {
    setModelInitialAction,
    setActiveTabAction,
    isParametersOrVariablesUpdatedAction,
    resetOriginalValuesAction,
} from '../../../../stores/actions/modelInputReader';
import { ModelHelper } from '../../modelFunctions';
import { updateLookerFrameAction } from '../../../../stores/actions/lookerActions';
import { updateLookerTabsVisited } from '../../../../stores/actions/lookerActions';
import { lookerParams } from '../../../../shared/lookerParams';
import { mergeRight } from 'ramda';
import ChangeModal from './changeModel';
import DeriveFromMedOrder from './deriveFromMedOrder';
import ShowMedModal from '../../../Common/Modal/medOrderModal';

const CHANGE_MODEL_TITLE = 'Change Model Source : TherigyVista';
const CHANGE_MED_ORDER_MODEL_TITLE = 'Import Med Order Data - Model ';

class ModelInput extends Component {
    constructor(props) {
        super(props);
        let session = localStorage.getItem('FOM_user');
        this.state = {
            open: false,
            reset: false,
            showPropData: false,
            activeTab: 'Physician',
            userdata: session ? JSON.parse(session).userdata.details : null,
            isChanged: false,
            showToast: false,
            properietryData: null,
            masterModel: null,
            showModal: false,
            showMedOrderModal: false,
            api: {
                response: {
                    status: '',
                    message: '',
                },
            },
            changedFlags: {
                Revenue: false,
                PayerMix: false,
                MarginProfit: false,
                Physician: false,
                PatientRx: false,
                AccessRate: false,
                '340B': false,
            },
            lookerParams: {},
        };
        this.handleTabChange = this.handleTabChange.bind(this);
        this.setOpen = this.setOpen.bind(this);
        this.handleApply = this.handleApply.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.afterApplied = this.afterApplied.bind(this);
        this.handleApplyProprietary = this.handleApplyProprietary.bind(this);
        this.loadDefaultProprietaryData = this.loadDefaultProprietaryData.bind(this);
        this.handleDefaultApply = this.handleDefaultApply.bind(this);
        this.handleValidateAndSaveModel = this.handleValidateAndSaveModel.bind(this);
        this.toggleModel = this.toggleModel.bind(this);
        this.modelInputService = new modelInputService();
        this.modelDetailsService = new modelDetailsService();
        this.loadMedOrders = this.loadMedOrders.bind(this);
        this.toggleMedOrderModel = this.toggleMedOrderModel.bind(this);
        this.getPharmacyDetails = this.getPharmacyDetails.bind(this);
        this.getRXOrderDate = this.getRXOrderDate.bind(this);
        this.getRXNonFilteredDateList = this.getRXNonFilteredDateList.bind(this);
        this.getCustomerDrugNonAccessList = this.getCustomerDrugNonAccessList.bind(this);
        this.loadMedOrder = this.loadMedOrder.bind(this);
    }
    //  below looker url object is expected as is by the API service to fetch embedded URLS
    mapLookerUrls(lookerPaths) {
        return lookerPaths;
    }

    initialResetFlags() {
        return {
            Addressable: false,
            InputVariables: false,
            RevenueByPayor: false,
            RevenueOpportunity: false,
            AddrRevByPayor: false,
            MarginByPayor: false,
            AddrMarginByPayor: false,
            FiveYearProjections: false,
            FiveYearProjectionsLoaded: false,
        };
    }

    /**
     * Render dom elements
     */
    render() {
        const { activeTab, open, api, showToast, userdata, showPropData, masterModel, changedFlags, showModal, showMedOrderModal } =
            this.state;

        let modelDetails = {};
        if (this.props.modelDetails) {
            modelDetails = this.props.modelDetails.modelPayload.modelDetails;
        }

        let modelName = "";
        if (this.props.modelDetails) {
            modelName = modelDetails.modelName;
        }

        let showChangeModelSourceButton = false;
        if (
            userdata &&
            userdata.role === Config.user.role.admin &&
            masterModel &&
            masterModel.modelId !== modelDetails.modelId
        ) {
            showChangeModelSourceButton = true;
        }

        let showProprietaryToggleButton = false;
        if (userdata && userdata.role !== Config.user.role.customer) {
            showProprietaryToggleButton = true;
        }

        let showApplyButton = false;
        if (this.props.isVariablesOrParamsUpdated.status) {
            showApplyButton = true;
        }

        if (!this.props.isVariablesOrParamsUpdated.status) {
            for (var i in changedFlags) {
                changedFlags[i] = false;
            }
        } else {
            this.updateChangeFlags(changedFlags);
        }

        const errors = ModelHelper.validateModel(
            R.applySpec({
                parameters: R.pathOr([], ['initial', 'parameters']),
            })(this.props.getInitialModels),
        );

        return (
            <div>
                <div>
                    {showModal ? (
                        <ShowModal
                            toggleModel={this.toggleModel}
                            show={showModal}
                            title={CHANGE_MODEL_TITLE}
                            renderModalBody={
                                <ChangeModal
                                    toggleModel={this.toggleModel}
                                    loadDefaultProprietaryData={this.loadDefaultProprietaryData}
                                    loadMedOrders={this.loadMedOrders}
                                />
                            }
                        />
                    ) : null}

                    {showMedOrderModal ? (
                        <ShowMedModal
                            toggleModel={this.toggleMedOrderModel}
                            show={showMedOrderModal}
                            title={CHANGE_MED_ORDER_MODEL_TITLE +  modelName}
                            renderModalBody={
                                <DeriveFromMedOrder
                                    getRXOrderDate = {this.getRXOrderDate}
                                    getRXNonFilteredDateList = {this.getRXNonFilteredDateList}
                                    loadMedOrder={this.loadMedOrder}
                                    toggleMedOrderModel={this.toggleMedOrderModel}
                                    getPharmacyDetails ={this.getPharmacyDetails}
                                    getCustomerDrugNonAccessList={this.getCustomerDrugNonAccessList}
                                    loadDefaultProprietaryData={this.loadDefaultProprietaryData}
                                />
                            }
                        />
                    ) : null}
                </div>
                <Row>
                    <Col md={12}>
                        <div className="box-head" onClick={this.setOpen}>
                            <p className="m-0">MODEL INPUT</p>
                            <div className="icon-box">
                                {open ? <FontAwesomeIcon icon={faAngleUp} /> : <FontAwesomeIcon icon={faAngleDown} />}
                            </div>
                        </div>
                    </Col>
                </Row>
                <Collapse in={open}>
                    <Row>
                        <Col md={12}>
                            <div className="tab-container">
                                <Row>
                                    <Col md={12} className="pt-2 pb-0">
                                        <div className="button-group mr-4">
                                            {showProprietaryToggleButton ? (
                                                <Row className="showPropData">
                                                    <span>Show Proprietary Data</span>
                                                    <ToggleButton
                                                        width={'50px'}
                                                        inactiveLabel={'NO'}
                                                        activeLabel={'YES'}
                                                        value={showPropData || false}
                                                        colors={{
                                                            activeThumb: {
                                                                base: 'rgb(247, 247, 247)',
                                                            },
                                                            inactiveThumb: {
                                                                base: 'rgb(247, 247, 247)',
                                                            },
                                                            active: {
                                                                base: 'rgb(26, 108, 157, 1)',
                                                                hover: 'rgb(26, 108, 157, 1)',
                                                            },
                                                            inactive: {
                                                                base: 'rgb(65,66,68)',
                                                                hover: 'rgb(95,96,98)',
                                                            },
                                                        }}
                                                        onToggle={(value) => {
                                                            this.setState({
                                                                showPropData: !value,
                                                            });
                                                        }}
                                                    />
                                                </Row>
                                            ) : null}
                                            <Button
                                                id="btn-model-apply"
                                                className="btn-apply btn-sm"
                                                disabled={showApplyButton && modelDetails.modelId ? null : 'disabled'}
                                                onClick={this.handleApply}
                                            >
                                                <FontAwesomeIcon icon={faPlay} />
                                                <span className="ml-3">Apply</span>
                                            </Button>
                                            {showChangeModelSourceButton ? (
                                                <Button
                                                    className="btn-properietry btn-sm"
                                                    disabled={modelDetails.modelId ? null : 'disabled'}
                                                    onClick={this.handleApplyProprietary} // TODO : update this call with a functional modal call in TI-4279
                                                >
                                                    <FontAwesomeIcon icon={faSlidersH} />
                                                    <span className="ml-3">Change Model Source</span>
                                                </Button>
                                            ) : null}
                                            <Button
                                                id="btn-model-reset"
                                                className="btn-reset btn-sm"
                                                disabled={showApplyButton && modelDetails.modelId ? null : 'disabled'}
                                                onClick={this.handleReset}
                                            >
                                                <FontAwesomeIcon icon={faUndo} />
                                                <span className="ml-3">Reset</span>
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>

                                {errors ? (
                                    <Row>
                                        <Col md="auto" style={{ marginLeft: 10 }}>
                                            <div>{errors}</div>
                                        </Col>
                                    </Row>
                                ) : null}

                                <Row>
                                    <Col md={12}>
                                        <div className="tab-container">
                                            <Tabs
                                                id="model-inputs"
                                                activeKey={activeTab}
                                                defaultActiveKey="Physician"
                                                className="pt-2 pl-2 bg-white"
                                                onSelect={this.handleTabChange}
                                            >
                                                <Tab
                                                    eventKey="Physician"
                                                    className="bg-white"
                                                    title={
                                                        <span>
                                                            Physician{' '}
                                                            {changedFlags['Physician'] ? (
                                                                <span className="tab-change-indicator">*</span>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </span>
                                                    }
                                                >
                                                    <PhysicianVariables
                                                        activeTab={activeTab}
                                                        onLoadComplete={this.onLoadComplete}
                                                    />
                                                </Tab>

                                                {showPropData ? (
                                                    <Tab
                                                        eventKey="PatientRx"
                                                        className="bg-white"
                                                        title={
                                                            <span>
                                                                Patient &amp; RX{' '}
                                                                {changedFlags['PatientRx'] ? (
                                                                    <span className="tab-change-indicator">*</span>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </span>
                                                        }
                                                    >
                                                        <PatientRxVariables
                                                            activeTab={activeTab}
                                                            onLoadComplete={this.onLoadComplete}
                                                        />
                                                    </Tab>
                                                ) : null}

                                                <Tab
                                                    eventKey="Revenue"
                                                    className="bg-white"
                                                    title={
                                                        <span>
                                                            Revenue{' '}
                                                            {changedFlags['Revenue'] ? (
                                                                <span className="tab-change-indicator">*</span>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </span>
                                                    }
                                                >
                                                    <RevenueParameters
                                                        activeTab={activeTab}
                                                        onLoadComplete={this.onLoadComplete}
                                                    />
                                                </Tab>

                                                <Tab
                                                    eventKey="DrugAccess"
                                                    className="bg-white"
                                                    title={
                                                        <span>
                                                            Drug Access{' '}
                                                            {changedFlags['DrugAccess'] ? (
                                                                <span className="tab-change-indicator">*</span>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </span>
                                                    }
                                                >
                                                    <DrugAccessVariables
                                                        activeTab={activeTab}
                                                        className="tab-iv"
                                                        onLoadComplete={this.onLoadComplete}
                                                    />
                                                </Tab>

                                                <Tab
                                                    eventKey="PayorMix"
                                                    className="bg-white"
                                                    title={
                                                        <span>
                                                            Payor Mix{' '}
                                                            {changedFlags['PayorMix'] ? (
                                                                <span className="tab-change-indicator">*</span>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </span>
                                                    }
                                                >
                                                    <PayorMixParameters
                                                        activeTab={activeTab}
                                                        className="tab-iv"
                                                        onLoadComplete={this.onLoadComplete}
                                                    />
                                                </Tab>

                                                {showPropData ? (
                                                    <Tab
                                                        eventKey="PayorAccess"
                                                        className="bg-white"
                                                        title={
                                                            <span>
                                                                Payor Access{' '}
                                                                {changedFlags['PayorAccess'] ? (
                                                                    <span className="tab-change-indicator">*</span>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </span>
                                                        }
                                                    >
                                                        <PayorAccessVariables
                                                            activeTab={activeTab}
                                                            onLoadComplete={this.onLoadComplete}
                                                        />
                                                    </Tab>
                                                ) : null}

                                                <Tab
                                                    eventKey="MarginProfit"
                                                    className="bg-white"
                                                    title={
                                                        <span>
                                                            Non-340B Margin{' '}
                                                            {changedFlags['MarginProfit'] ? (
                                                                <span className="tab-change-indicator">*</span>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </span>
                                                    }
                                                >
                                                    <MarginProfitParameters
                                                        activeTab={activeTab}
                                                        onLoadComplete={this.onLoadComplete}
                                                    />
                                                </Tab>

                                                {showPropData ? (
                                                    <Tab
                                                        eventKey="340B"
                                                        className="bg-white"
                                                        title={
                                                            <span>
                                                                340B Eligibility &amp; Margin
                                                                {changedFlags['340B'] ? (
                                                                    <span className="tab-change-indicator">*</span>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </span>
                                                        }
                                                    >
                                                        <B340Variables
                                                            activeTab={activeTab}
                                                            onLoadComplete={this.onLoadComplete}
                                                        />
                                                    </Tab>
                                                ) : null}
                                            </Tabs>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Collapse>

                <Toast className="toast-container" show={showToast} onClose={this.toggleToast}>
                    <Toast.Header className={` ${api.response.status !== 'Failure' ? 'success' : 'error'}`}>
                        <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
                        <strong className="mr-auto">{api.response.status}</strong>
                    </Toast.Header>
                    <Toast.Body>{api.response.message}</Toast.Body>
                </Toast>
            </div>
        );
    }

    updateChangeFlags(changedFlags) {
        if (this.props.isVariablesOrParamsUpdated.status) {
            if (this.props.isVariablesOrParamsUpdated.group === 'Revenue Parameters') {
                changedFlags['Revenue'] = true;
            }
            if (this.props.isVariablesOrParamsUpdated.group === 'Payer Mix Parameters') {
                changedFlags['PayorMix'] = true;
            }
            if (this.props.isVariablesOrParamsUpdated.group === 'Margin & Profitability Assumptions') {
                changedFlags['MarginProfit'] = true;
            }
            if (this.props.isVariablesOrParamsUpdated.group === 'Physician') {
                changedFlags['Physician'] = true;
            }
            if (this.props.isVariablesOrParamsUpdated.group === 'Patient & RX') {
                changedFlags['PatientRx'] = true;
            }
            if (this.props.isVariablesOrParamsUpdated.group === 'Payor Access') {
                changedFlags['PayorAccess'] = true;
            }
            if (this.props.isVariablesOrParamsUpdated.group === '340B') {
                changedFlags['340B'] = true;
            }
        }
    }

    /**
     * Component Mount Methods
     */
    componentDidMount() {
        this.props.setActiveTab(this.state.activeTab);
        if (localStorage.getItem('FOM_master_model')) {
            this.setState({
                masterModel: JSON.parse(localStorage.getItem('FOM_master_model')),
            });
        }
    }

    /**
     * Handle tab change
     * @param {*} tabName tab name
     */
    handleTabChange(tabName) {
        this.setState({
            activeTab: tabName,
        });
    }

    /**
     * On load complete
     */
    onLoadComplete = () => {
        this.setState({});
    };

    /**
     * Apply button click
     */
    handleApply() {
        let modelDetails =
            this.props.modelDetails && this.props.modelDetails.modelPayload
                ? this.props.modelDetails.modelPayload.modelDetails
                : null;

        let variables =
            this.props.getInitialModels && this.props.getInitialModels.initial
                ? this.props.getInitialModels.initial.variables
                : null;
        if (variables) {
            variables = ModelHelper.filterComputedVariables(variables);
        }
        let parameters =
            this.props.getInitialModels && this.props.getInitialModels.initial
                ? this.props.getInitialModels.initial.parameters
                : null;

        let params = {
            modelId: modelDetails ? modelDetails.modelId : null,
            modelVersionId: modelDetails ? modelDetails.modelVersionId : null,
            variables: variables,
            parameters: parameters,
        };

        this.handleValidateAndSaveModel(params);
    }

    handleDefaultApply() {
        const { properietryData } = this.state;

        let modelDetails =
            this.props.modelDetails && this.props.modelDetails.modelPayload
                ? this.props.modelDetails.modelPayload.modelDetails
                : null;

        let variables = properietryData.variables;
        if (variables) {
            variables = ModelHelper.filterComputedVariables(variables);
        }
        let parameters = properietryData.parameters;

        let params = {
            modelId: modelDetails ? modelDetails.modelId : null,
            modelVersionId: modelDetails ? modelDetails.modelVersionId : null,
            variables: variables,
            parameters: parameters,
        };

        this.handleValidateAndSaveModel(params);
    }

    handleValidateAndSaveModel(params) {
        // validate model inputs
        var errors = ModelHelper.validateModel(params);
        if (errors) {
            // set error on form validation
            this.setState({
                showError: true,
                api: {
                    response: {
                        status: 'Failure',
                        message: errors,
                    },
                },
            });
            this.toggleToast();
            return;
        }

        // save model

        params = mergeRight(params, lookerParams);
        this.modelInputService.saveApplyModel(params).then((res) => {
            if (res.status === 'Success') {
                this.afterApplied(res);
            } else {
                this.setState({
                    api: {
                        response: {
                            status: res.status,
                            message: res.message,
                        },
                    },
                });
                this.toggleToast();
            }
        });
        // }
    }

    /**
     * Apply propreitary button click
     */
    handleApplyProprietary() {
        this.setState({
            showModal: true,
        });
    }

     /**
     * getPharmacyDetailsList
     */
      loadMedOrder(param){
        this.toggleModel();
        this.toggleMedOrderModel();
        let modelDetails = this.getModelDetails();

        let params = {
            customerId: modelDetails.customerId,
            modelId: modelDetails.modelId,
            ...param
        };
        return  this.modelDetailsService.loadMedOrder(params).then((res) => {
            if (res && res.status === 200 && res.data) {
                return res.data.data;
            }
        });

      }

    /**
     * get Pharmacy Details List
     */
     getRXNonFilteredDateList(){
        let modelDetails = this.getModelDetails();

        let params = {
            customerId: modelDetails.customerId,
        };
        return this.modelDetailsService.getRXNonFilteredDateList(params).then((res) => {
            if (res && res.status === 200 && res.data) {
                return res.data.data;
            }
        });
       
    }

     /**
     * get Pharmacy Details List
     */
      getRXOrderDate(){
        let modelDetails = this.getModelDetails();

        let params = {
            customerId: modelDetails.customerId,
        };
        return  this.modelDetailsService.getRXOrderDate(params).then((res) => {
            if (res && res.status === 200 && res.data) {
                return res.data.data;
            }
        });
    }

    /**
     * get Pharmacy Details List
     */
     getPharmacyDetails () {
        let modelDetails = this.getModelDetails();
            
        let params = {
            customerId: modelDetails.customerId,
        };

      return this.modelDetailsService.getPharmacyDetails(params).then((res) => {
            if (res && res.status === 200 && res.data) {
                console.log("res.data.data", res.data);
                return res.data.data;
            }
        });
    }

    /**
     * get customer drug non access list
     */
     getCustomerDrugNonAccessList(){
        let modelDetails = this.getModelDetails();

        let params = {
            customerId: modelDetails.customerId,
        };
        return this.modelDetailsService.getCustomerDrugNonAccessList(params).then((res) => {
            if (res && res.status === 200 && res.data) {
                return res.data.data;
            }
        });
    }

    getModelDetails(){
        let modelDetails =
        this.props.modelDetails && this.props.modelDetails.modelPayload
            ? this.props.modelDetails.modelPayload.modelDetails
            : null;
        return modelDetails;
    }

    /**
     * Apply Default Model
     */
    loadDefaultProprietaryData() {
        this.modelDetailsService.getDefaultModel(lookerParams).then((res) => {
            if (res.status === 'Success' && res.data) {
                this.setState({
                    properietryData: res.data,
                });

                this.setParamsAndVariables(res.data);
                this.handleDefaultApply();
            }
        });
        this.toggleModel();
    }

     /**
     * Apply loadMedOrders
     */
      loadMedOrders() {
        this.setState((prevState) => ({
            showMedOrderModal: !prevState.showMedOrderModal,
        }));
    }

    /**
     * Apply loadMedOrders
     */
     toggleMedOrderModel() {
        this.setState((prevState) => ({
            showMedOrderModal: !prevState.showMedOrderModal,
        }));
    }


    toggleModel() {
        this.setState((prevState) => ({
            showModal: !prevState.showModal,
        }));
    }

    

    /**
     * Set param and variables
     * @param {*} data
     */
    setParamsAndVariables(data) {
        this.props.setInitialModel(data);
        this.props.setVariablesUpdated(true);
    }

    /**
     * Reset button click
     */
    handleReset() {
        let modelDetails =
            this.props.modelDetails && this.props.modelDetails.modelPayload
                ? this.props.modelDetails.modelPayload.modelDetails
                : null;
        if (modelDetails) {
            let params = {
                modelId: modelDetails.modelId,
                versionId: modelDetails.modelVersionId,
            };
            this.modelDetailsService.getSingleModel(params).then((res) => {
                if (res.status === 'Success' && res.data) {
                    this.setParamsAndVariables(res.data);
                    this.props.updateModel(res.data);
                    this.props.setVariablesUpdated(false);
                }
            });
        }
    }

    /**
     * Called after the model input is saved successfully
     */
    afterApplied(res) {
        let lookerPaths = res.data.lookerPath;
        let lookerUrls = this.mapLookerUrls(lookerPaths);
        let resetTabFlags = this.initialResetFlags();
        this.props.updateTabVisited(resetTabFlags);
        this.props.updateLooker(lookerUrls);
        const setModifiedData = {
            modifiedBy: res.data.modifiedBy,
            modifiedDate: res.data.modifiedDate,
        };
        this.props.updateModifiedDate(setModifiedData);
        this.setState({
            api: {
                response: {
                    status: res.status,
                    message: res.message,
                },
            },
        });
        this.props.setVariablesUpdated(false);
        this.props.resetOriginalValues(true);
        this.props.resetOriginalValues(false);
        this.toggleToast();
    }

    /**
     * Props change auto invoke function
     */
    static getDerivedStateFromProps(props, current_state) {
        if (props.isVariablesOrParamsUpdated.status !== current_state.isChanged) {
            return {
                isChanged: props.isVariablesOrParamsUpdated.status,
            };
        }
        return null;
    }

    /**
     * Set div open or hide
     */
    setOpen() {
        this.setState({
            open: !this.state.open,
        });
    }

    /**
     * Toggle toast
     */
    toggleToast = () => {
        const { showToast } = this.state;
        this.setState({
            showToast: !showToast,
        });
        setTimeout(() => {
            this.setState({
                showToast: false,
            });
        }, 10000);
    };
}

/**
 * Set redux state to props
 * @param {*} state
 */
const MapStateToProps = (state) => {
    return {
        getInitialModels: state.getInitialAction,
        revenueParametersData: state.revParamAction,
        inputvariablesData: state.inpVarblAction,
        modelDetails: state.modelChangeAction,
        setModelData: PropTypes.func,
        getModelStatus: state.modalOnCloseAction,
        isVariablesOrParamsUpdated: state.paramsVariablesUpdated,
    };
};

/**
 * Dispatching redux actions
 */
const MapDispatchToProps = (dispatch) => {
    return {
        setActiveTab: (params) => dispatch(setActiveTabAction(params)),
        setInitialModel: (params) => dispatch(setModelInitialAction(params)),
        updateModel: (params) => dispatch(modelChangeAction(params)),
        updateLooker: (params) => dispatch(updateLookerFrameAction(params)),
        updateTabVisited: (params) => dispatch(updateLookerTabsVisited(params)),
        updateModifiedDate: (params) => dispatch(setModifiedDateAction(params)),
        setVariablesUpdated: (status, group) => dispatch(isParametersOrVariablesUpdatedAction(status, group)),
        setModelData: (params) => dispatch(modalOnOpenAction(params)),
        modelStatus: (params) => dispatch(modalOnCloseAction(params)),
        resetOriginalValues: (params) => dispatch(resetOriginalValuesAction(params)),
    };
};

ModelInput.propTypes = {
    getInitialModels: PropTypes.object,
    revenueParametersData: PropTypes.object,
    setInitialModel: PropTypes.func,
    inputvariablesData: PropTypes.object,
    modelDetails: PropTypes.object,
    setActiveTab: PropTypes.func,
    setVariablesUpdated: PropTypes.func,
    isVariablesOrParamsUpdated: PropTypes.object,
    reset: PropTypes.func,
    updateModel: PropTypes.func,
    updateModifiedDate: PropTypes.func,
    modelStatus: PropTypes.func.isRequired,
    getModelStatus: PropTypes.object.isRequired,
    setModelData: PropTypes.func,
    resetOriginalValues: PropTypes.func,
    updateLooker: PropTypes.func,
    updateTabVisited: PropTypes.func,
};

export default connect(MapStateToProps, MapDispatchToProps)(ModelInput);
